import { useMemo } from "react";

import { usePlaybooksListQuery } from "../queries/usePlaybooksListQuery";

export const useScoringRuleUsageByPlaybook = (currentPlaybookId?: number): ReadonlyMap<string, string[]> => {
    const { data: playbooks = [] } = usePlaybooksListQuery();

    return useMemo(() => {
        const usageMap = new Map<string, string[]>();

        for (const playbook of playbooks) {
            if (currentPlaybookId !== undefined && playbook.playbookId === currentPlaybookId) {
                continue;
            }

            if (!playbook.name) {
                continue;
            }

            const names = usageMap.get(playbook.scoringRuleId) ?? [];
            names.push(playbook.name);
            usageMap.set(playbook.scoringRuleId, names);
        }

        return usageMap;
    }, [currentPlaybookId, playbooks]);
};
